var _rect, _g, _rect2, _circle, _circle2, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 18",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Malaysia flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "#FFFFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#CC0001"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 24,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 24,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 24,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 24,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 24,
    height: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 10,
    fill: "#010066"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.1,
    cy: 5,
    r: 2.7,
    fill: "#FFCC00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 5,
    r: 2.2,
    fill: "#010066"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "8.7,2.2 9.3,3.8 11.1,3.8 9.7,4.9 10.2,6.5 8.7,5.5 7.2,6.5 7.7,4.9 6.3,3.8 8.1,3.8",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/my.249f11a2c58f7cf55a514e78cd17b76c.svg";
export { ForwardRef as ReactComponent };